import { useState, useMemo } from "react"
import { useFormik } from "formik"
import * as Yup from "yup"

import { REFUND_TABS } from "types/shared"
import { useUI } from "providers/UIProvider"
import { useTransactionsContext } from "providers/TransactionsProvider/TransactionsProvider"

const REFUND_FORM_VALIDATION_SCHEMA = (T: any, isFully: boolean) =>
  Yup.object({
    amount: Yup.lazy((value) => {
      if (isFully) {
        return Yup.string()
      }

      if (value === "") {
        return Yup.string()
      }

      return Yup.number().required(T("refund.form.validations.amount_required"))
    }),
  })

const useRefund = () => {
  const { modals, T } = useUI()
  const { refundTransaction } = useTransactionsContext()
  const [currentTab, setCurrentTab] = useState(REFUND_TABS.PARTLY)

  const refundModalData = modals.refundModal.data

  const onSubmit = (values: any) => {
    refundTransaction({
      paymentId: refundModalData!.transactionId,
      returnAmount:
        currentTab === REFUND_TABS.FULLY
          ? refundModalData?.price
          : values.amount,
      returnFullAmount: currentTab === REFUND_TABS.FULLY,
    })
  }

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: { amount: "" },
      validationSchema: () =>
        REFUND_FORM_VALIDATION_SCHEMA(T, currentTab === REFUND_TABS.FULLY),
      onSubmit,
    })

  const handleTabChange = (newTab: REFUND_TABS) => setCurrentTab(newTab)

  return useMemo(
    () => ({
      form: {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
      },
      currentTab,
      handleTabChange,
    }),
    [values, errors, touched, currentTab],
  )
}

export default useRefund
